"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _Modal = require("@insided/shared/uikit/Modal");

var _seatsService = require("@insided/deprecated-control/services/seatsService");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SeatLimitWarningModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SeatLimitWarningModal, _Component);

  var _super = _createSuper(SeatLimitWarningModal);

  function SeatLimitWarningModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SeatLimitWarningModal);
    _this = _super.call(this, props);
    _this.state = {
      limit: 0,
      current: 0,
      isOpen: true
    };
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SeatLimitWarningModal, [{
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var response, _response$data, limit, current;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _seatsService.seatsService.getData();

              case 2:
                response = _context.sent;
                _response$data = response.data, limit = _response$data.limit, current = _response$data.current;
                this.setState({
                  limit: limit,
                  current: current
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var previousSeatCount = this.props.previousSeatCount;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          limit = _this$state.limit,
          current = _this$state.current;
      var shouldDisplay = isOpen && limit > 0 && current > limit && current > (previousSeatCount !== null && previousSeatCount !== void 0 ? previousSeatCount : 0);
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: shouldDisplay,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "You've exceeded your seat limit",
        onClose: this.closeModal
      }), (0, _preact.h)(_Modal.ModalBody, null, "\uD83C\uDFB8 Great that your team is growing! By changing this user\u2019s role, you went over your current seat limit. That\u2019s no problem - you can still continue. We'll reach out to discuss adjusting your limit, and won\u2019t charge you anything without your consent."), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        title: "Okay, got it",
        onClick: function onClick() {
          return _this2.closeModal();
        },
        variant: "primary"
      }), (0, _preact.h)("button", {
        style: {
          display: 'none'
        }
      }), (0, _preact.h)(_buttonControl.default, {
        title: "Review your seat usage",
        onClick: function onClick() {
          return window.open('/team', '_blank');
        }
      })));
    }
  }]);
  return SeatLimitWarningModal;
}(_preact.Component);

var _default = SeatLimitWarningModal;
exports.default = _default;